<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Corporate Details</ion-title>
        </ion-buttons>
        <ion-buttons slot="end">
        <ion-button class="hdrBtn" @click="addNewCPO">
            <ion-icon v-slot: start :icon="add" ></ion-icon>&nbsp;Add Corporate Name
            <!-- <ion-icon slot="icon-only" name="add"></ion-icon>  class="btn-add" -->
        </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <CorporateNameList />
    </ion-content>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
// import CreateCorporateName from "@/components/admin/createCorporateName.vue";
import CorporateNameList from "@/components/admin/CorporateNameList.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
  name:  'corporateNameList',
  components: {
    CorporateNameList, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
      add
    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    
    addNewCPO() {
      this.$router.push("addNewCorporate"); 
    }
  }
})
</script>